"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = (dispatch, authenticationManager) => ({
  async authenticationFailureInterceptor(error) {
    if (error.response && error.response.status === 401) {
      await dispatch('authentication/clearToken', null, {
        root: true
      }); // eslint-disable-next-line no-undef

      window.location.replace(`/?tokenExpired=true&from=${window.location.pathname}`);
      return;
    }

    throw error;
  },

  async bearerTokenInterceptor(config) {
    await authenticationManager.executeSilentRefreshToken(5 * 60 * 1000); // eslint-disable-next-line no-param-reassign

    config.headers = Object.assign({}, config.headers, {
      Authorization: authenticationManager.getBearer()
    });
    return config;
  }

});

exports.default = _default;